import * as z from 'zod';

import { invoiceBatchFormSchema } from '../schemas/invoice-batch';

// invoiceFormSchema has refinements, and Zod v4 disallows .pick() directly on refined objects.
// Clone from `.shape` first to keep the same field definitions without refinement checks.
const invoiceBatchFormObjectSchema = z.object(invoiceBatchFormSchema.shape);

export const invoiceBatchFilterSchema = invoiceBatchFormObjectSchema.pick({
  name: true,
  is_paid: true,
  invoices_creation_date: true,
  payment_date: true,
  payment_method: true,
});

export type InvoiceBatchFilterSchema = z.infer<typeof invoiceBatchFilterSchema>;
